import { mapState } from 'vuex';
import { GAME_LANUGAME } from '@store/officialStore/gameConf';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      lang: state => state.lang,
      curLocation: state => state.curLocation
    }),
    extraTip() {
      return function (item) {
        // 蚂蚁日本地区加码下架
        const directGameExtra = {
          263: '10%'
        };
        if (directGameExtra[+this.gameId] && this.curLocation !== 'JP') {
          return this.letter.gainPlus + directGameExtra[+this.gameId];
        }
        // 加码比例，key加不加引号Object.keys返回的都是字符串数组
        const maxExtraRatioMap = {
          213: '50%',
          // 209: '50%', // 2025.9.26 日本大掌柜下架加码 https://www.tapd.cn/tapd_fe/34575918/story/detail/1134575918001293930
          211: '50%',
          215: '12%',
          191: '10%'
        };
        if (maxExtraRatioMap[+this.gameId]) {
          if (item.PRODUCT_TYPE == 'currency') {
            return this.maxExtraRatio
              ? this.maxExtraRatio.replace(
                  '$rate',
                  maxExtraRatioMap[this.gameId]
                )
              : this.letter.gainMostPlus + maxExtraRatioMap[this.gameId];
          }
          return this.maxExtraRatio
            ? this.maxExtraRatio.replace('$rate', '10%')
            : this.letter.gainMostPlus + '10%';
        }
        return '';
      };
    },
    maxExtraRatio() {
      if (
        GAME_LANUGAME[this.gameId] &&
        GAME_LANUGAME[this.gameId][this.lang] &&
        GAME_LANUGAME[this.gameId][this.lang]['maxExtraRatio']
      ) {
        return GAME_LANUGAME[this.gameId][this.lang]['maxExtraRatio'];
      }
      return '';
    }
  }
};
